namespace GeniuzPOS.ReportMasterData {
    export interface Report_1201Row {
        Id?: number;
        DocNo?: string;
        DocDate?: string;
        DocTime?: string;
        RefDocNo?: string;
        PosId?: string;
        ShopId?: string;
        ShopName?: string;
        ShopTypeId?: string;
        ShopTypeName?: string;
        ShopGroupId?: string;
        ShopGroupName?: string;
        CashierId?: string;
        CashierName?: string;
        MbId?: string;
        MbNameT?: string;
        SalesmanId?: string;
        SalesmanName?: string;
        SalesVatType?: string;
        Factor?: number;
        GrossSales?: number;
        TotalItem?: number;
        TotalQty?: number;
        AllItemDiscount?: number;
        AdvDiscount?: number;
        AllItemCharge?: number;
        BillDiscount?: number;
        NetSales?: number;
        BillCharge?: number;
        DocAmt?: number;
        Vat?: number;
        RoundAdjust?: number;
        NetSalesNormal?: number;
        NetSalesPromo?: number;
        NetSalesExVat?: number;
        NetSalesNonVat?: number;
        VatOfNetSales?: number;
        VatOfCharge?: number;
        ReceiveCash?: number;
        ReceiveCreditCd?: number;
        ReceiveDebitCd?: number;
        ReceiveCoupon?: number;
        ReceiveCashCd?: number;
        ReceivePoint?: number;
        ReceiveOthers?: number;
        ReceiveNet?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        DtList?: Report_1201_DtRow[];
        DiscList?: Report_1201_DiscRow[];
        RecvList?: Report_1201_RecvRow[];
    }

    export namespace Report_1201Row {
        export const idProperty = 'DocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'ReportMasterData.Report_1201';
        export const lookupKey = 'Report_1201Row';

        export function getLookup(): Q.Lookup<Report_1201Row> {
            return Q.getLookup<Report_1201Row>('Report_1201Row');
        }
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            DocDate = "DocDate",
            DocTime = "DocTime",
            RefDocNo = "RefDocNo",
            PosId = "PosId",
            ShopId = "ShopId",
            ShopName = "ShopName",
            ShopTypeId = "ShopTypeId",
            ShopTypeName = "ShopTypeName",
            ShopGroupId = "ShopGroupId",
            ShopGroupName = "ShopGroupName",
            CashierId = "CashierId",
            CashierName = "CashierName",
            MbId = "MbId",
            MbNameT = "MbNameT",
            SalesmanId = "SalesmanId",
            SalesmanName = "SalesmanName",
            SalesVatType = "SalesVatType",
            Factor = "Factor",
            GrossSales = "GrossSales",
            TotalItem = "TotalItem",
            TotalQty = "TotalQty",
            AllItemDiscount = "AllItemDiscount",
            AdvDiscount = "AdvDiscount",
            AllItemCharge = "AllItemCharge",
            BillDiscount = "BillDiscount",
            NetSales = "NetSales",
            BillCharge = "BillCharge",
            DocAmt = "DocAmt",
            Vat = "Vat",
            RoundAdjust = "RoundAdjust",
            NetSalesNormal = "NetSalesNormal",
            NetSalesPromo = "NetSalesPromo",
            NetSalesExVat = "NetSalesExVat",
            NetSalesNonVat = "NetSalesNonVat",
            VatOfNetSales = "VatOfNetSales",
            VatOfCharge = "VatOfCharge",
            ReceiveCash = "ReceiveCash",
            ReceiveCreditCd = "ReceiveCreditCd",
            ReceiveDebitCd = "ReceiveDebitCd",
            ReceiveCoupon = "ReceiveCoupon",
            ReceiveCashCd = "ReceiveCashCd",
            ReceivePoint = "ReceivePoint",
            ReceiveOthers = "ReceiveOthers",
            ReceiveNet = "ReceiveNet",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            DtList = "DtList",
            DiscList = "DiscList",
            RecvList = "RecvList"
        }
    }
}
